import React from "react";
import FilterProto from "../lib/filter-field-proto";

import FilterSelectorRag from "core/gd-app/panels/filters-panel/filter-form/multiselect/rag";

export default class FilterField2RAG extends FilterProto {

    optionsFillerFunc = false;

    constructor(filtersManager, field, initValue) {
        super(filtersManager, field, initValue, field.label);

        // this.filterConfig is field2 object

        this.field = this.filterConfig.fieldId;
        this.isCustomField = this.filterConfig.isCustom;

        // SET cannot have null first (!!!) like this this.optionsSet = new Set(null, 0, 1,2);
        this.optionsSet = new Set([null]);
        this.optionsSet.add(0);
        this.optionsSet.add(1);
        this.optionsSet.add(2);
    }

    getValue() {
        return this.value ? this.value : [...this.optionsSet];
    }

    setValue(val, silent=false) {
        // reset value to null if all options selected
        if (!val || [...this.optionsSet].length == val.length) {
            val = null;
            this.isEnabled = false;
        } else {
            this.isEnabled = true;
        }

        super.setValue(val, silent);
    }

    filterFunc(dataItem) {
        if (!this.value) return true; //null;
        let value = dataItem[this.filterConfig.fieldId];
        if(_.isNil(value)) value = null;
        return this.value.includes(value);
    }

    filterFuncUniversal(dataItem) {return this.filterFunc(dataItem)}

    render() {
        return <FilterSelectorRag filter={this} />
    }
}